// extracted by mini-css-extract-plugin
export var actions = "bH_fz";
export var content = "bH_V";
export var headline = "bH_fy";
export var imageContainer = "bH_bX";
export var singleCtaContainer = "bH_fw";
export var variant = "bH_fx";
export var wrapper = "bH_b5";